import { render, staticRenderFns } from "./InternalPromoClientComponent.vue?vue&type=template&id=704cd600"
import script from "./InternalPromoClientComponent.vue?vue&type=script&lang=js"
export * from "./InternalPromoClientComponent.vue?vue&type=script&lang=js"
import style0 from "./InternalPromoClientComponent.vue?vue&type=style&index=0&id=704cd600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports